var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dealer-search"}},[(_vm.loaded)?_c('router-view',{attrs:{"loaded":_vm.loaded}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }